module.exports = __webpack_public_path__ + "img/Comm-Link_17907_Banu_in_Festtagskleidung.7a17ffd4.png";